export default {"src":"/_next/static/media/0xfb5B838b6cfEEdC2873aB27866079AC55363D37E.df2c65f5.svg","height":71,"width":75,"blurWidth":0,"blurHeight":0};